export const settingActionTypes = <const>{
    SET_ACTIVE_SETTING_TAB: 'SET_ACTIVE_SETTING_TAB',
};
